import { DestroyRef, Directive, inject } from '@angular/core';
import { Subject } from 'rxjs';
import {
  AlertController,
  ModalController,
  NavController
} from '@ionic/angular';
import { Router } from '@angular/router';
import { LoadingService, NotificationService } from '../index';

@Directive()
export abstract class BaseAbstractPage {
  protected readonly destroy$ = new Subject<void>();
  protected readonly destroyRef = inject(DestroyRef);
  protected modalCtrl = inject(ModalController);
  protected router = inject(Router);
  protected navCtrl = inject(NavController);
  protected alertController = inject(AlertController);
  protected loadingService = inject(LoadingService);
  protected notificationService = inject(NotificationService);

  protected constructor() {}
}
